module.exports = __webpack_public_path__ + "static/media/image6.de4b7339.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/features/RestaurantAndCafe/components/Cafe/images/image6.jpg
// module id = 651
// module chunks = 0